import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { EndCustomerDuplicateGroup } from 'src/app/api/models/end-customer-duplicate-group';
import { EndCustomersService } from 'src/app/api/services';

/**
 * Lists the whitespace-duplicate end-customer groups (one row per trimmed
 * business id shared by two or more rows). The set is small (~41 groups), so
 * there is deliberately no pagination — a single fetch feeds the table. Opening
 * a row navigates to the merge view for that group.
 */
@Component({
  selector: 'app-end-customer-duplicates-page',
  templateUrl: './end-customer-duplicates-page.component.html',
  styleUrls: ['./end-customer-duplicates-page.component.scss']
})
export class EndCustomerDuplicatesPageComponent implements OnInit {
  readonly columns = ['business_id', 'member_count', 'names', 'invoices', 'flags'];

  groups$: Observable<EndCustomerDuplicateGroup[]>;

  constructor(private endCustomersService: EndCustomersService, private router: Router) { }

  ngOnInit(): void {
    // shareReplay so the template's async pipes (table + empty-state) share the
    // single HTTP request rather than issuing one each.
    this.groups$ = this.endCustomersService.listEndCustomerDuplicates().pipe(shareReplay(1));
  }

  openGroup(group: EndCustomerDuplicateGroup): void {
    this.router.navigate(['/end-customers/duplicates', group.business_id]);
  }

  /** Member names in id order, joined for the summary column. */
  memberNames(group: EndCustomerDuplicateGroup): string {
    return group.members.map(member => member.name ?? '—').join(', ');
  }

  /** Per-member invoice counts, in the same order as {@link memberNames}. */
  invoiceCounts(group: EndCustomerDuplicateGroup): string {
    return group.members.map(member => member.invoice_count).join(' / ');
  }
}
